import { render, staticRenderFns } from "./OtherProducts.vue?vue&type=template&id=a96053ec&scoped=true&"
import script from "./OtherProducts.vue?vue&type=script&lang=js&"
export * from "./OtherProducts.vue?vue&type=script&lang=js&"
import style0 from "./OtherProducts.vue?vue&type=style&index=0&id=a96053ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96053ec",
  null
  
)

export default component.exports